<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_kermanshah-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_kermanshah-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.825;"
  >
    <div
      id="g-p3_kermanshah-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_kermanshah-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.0203%;margin-top:-11.1px;left:0%;width:189px;"
    >
      <p class="g-pstyle0">Kermanshah missile facility</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.4018%;margin-top:-6.6px;left:7.9421%;width:77px;"
    >
      <p class="g-pstyle1">Kermanshah</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.6745%;margin-top:-14.7px;left:66.8145%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle2">Storage building</p>
      <p class="g-pstyle2">destroyed</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.9018%;margin-top:-6.6px;left:15.7812%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle3">IRAN</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.4245%;margin-top:-14.7px;left:35.8438%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle2">Structures</p>
      <p class="g-pstyle2">damaged</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_kermanshah-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.83469721767594;"
  >
    <div
      id="g-p3_kermanshah-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_kermanshah-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.4998%;margin-top:-11.2px;left:0%;width:213px;"
    >
      <p class="g-pstyle0">Kermanshah missile facility</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.7018%;margin-top:-7.5px;left:6.3414%;width:86px;"
    >
      <p class="g-pstyle1">Kermanshah</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.3205%;margin-top:-7.5px;left:12.2583%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.1535%;margin-top:-14.7px;left:67.1668%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle3">Storage building</p>
      <p class="g-pstyle3">destroyed</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.5414%;margin-top:-7.5px;left:35.9752%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle3">Structures damaged</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_kermanshah-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.82914572864322;"
  >
    <div
      id="g-p3_kermanshah-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_kermanshah-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.4233%;margin-top:-11.3px;left:0%;width:261px;"
    >
      <p class="g-pstyle0">Kermanshah missile facility</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.9449%;margin-top:-9.1px;left:6.3425%;width:96px;"
    >
      <p class="g-pstyle1">Kermanshah</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.583%;margin-top:-9.1px;left:12.2846%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.2665%;margin-top:-17.5px;left:67.193%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle3">Storage building</p>
      <p class="g-pstyle3">destroyed</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.6584%;margin-top:-9.1px;left:35.9825%;margin-left:-70.5px;width:141px;"
    >
      <p class="g-pstyle3">Structures damaged</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p3_kermanshah-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-p3_kermanshah-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_kermanshah-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-p3_kermanshah-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.93548387096774;"
  >
    <div
      id="g-p3_kermanshah-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_kermanshah-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:08 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:08 -->
<!-- ai file: p3_kermanshah.ai -->
<style lang="scss">
  #g-p3_kermanshah-box,
  #g-p3_kermanshah-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_kermanshah-box p {
    margin: 0;
  }
  #g-p3_kermanshah-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_kermanshah-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_kermanshah-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_kermanshah-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_kermanshah-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_kermanshah-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p3_kermanshah-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-p3_kermanshah-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-p3_kermanshah-xl {
        display: block !important;
      }
    }
  }
  #g-p3_kermanshah-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_kermanshah-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_kermanshah-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-p3_kermanshah-xs .g-pstyle1 {
    line-height: 12px;
    height: 12px;
    font-size: 10px;
    color: rgb(0, 0, 0);
  }
  #g-p3_kermanshah-xs .g-pstyle2 {
    height: 14px;
    text-align: center;
  }
  #g-p3_kermanshah-xs .g-pstyle3 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.2em;
    font-size: 10px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_kermanshah-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_kermanshah-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_kermanshah-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 16px;
    color: rgb(0, 0, 0);
  }
  #g-p3_kermanshah-sm .g-pstyle1 {
    height: 14px;
    color: rgb(0, 0, 0);
  }
  #g-p3_kermanshah-sm .g-pstyle2 {
    height: 14px;
    letter-spacing: 0.2em;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_kermanshah-sm .g-pstyle3 {
    height: 14px;
    text-align: center;
  }
  #g-p3_kermanshah-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_kermanshah-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_kermanshah-md .g-pstyle0 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 20px;
    color: rgb(0, 0, 0);
  }
  #g-p3_kermanshah-md .g-pstyle1 {
    height: 17px;
    color: rgb(0, 0, 0);
  }
  #g-p3_kermanshah-md .g-pstyle2 {
    height: 17px;
    letter-spacing: 0.2em;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_kermanshah-md .g-pstyle3 {
    height: 17px;
    text-align: center;
  }
  #g-p3_kermanshah-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p3_kermanshah-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_kermanshah-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_kermanshah-lg .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_kermanshah-lg .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-p3_kermanshah-xl {
    position: relative;
    overflow: hidden;
  }
  #g-p3_kermanshah-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_kermanshah-xl .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_kermanshah-xl .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_kermanshah-xl .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
